import CodeBlock from "@components/doc/CodeBlock";
import { TryExample } from "@configured/use-cases/CREPL";
import { ExampleSendingCodeBlock } from "./ExampleSendingCodeBlock";

export const IntegratedCodeBlock = ExampleSendingCodeBlock(
  CodeBlock,
  TryExample
);
